/**
 * @ngdoc enum
 * @name mx.shell.ActionPurpose
 * @module mx.shell
 *
 * @description
 * Represents the list of action purposes
 */
export enum ActionPurpose {
	/**
	 * @ngdoc property
	 * @name mx.shell.ActionPurpose#Create
	 *
	 * @description
	 * Action of such purpose are used for create
	 */
	Create = 1,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionPurpose#Edit
	 *
	 * @description
	 * Action of such purpose are used for edit
	 */
	Edit = 2,

	/**
	 * @ngdoc property
	 * @name mx.shell.ActionPurpose#Delete
	 *
	 * @description
	 * Action of such purpose are used for delete
	 */
	Delete = 3,
}
